(function () {
  if (window.cwcWorkshopServiceLeadTrackingInstalled) {
    return;
  }

  window.cwcWorkshopServiceLeadTrackingInstalled = true;

  var ALLOWED_ORIGIN = 'https://formbuilder.hulkapps.com';
  var FORM_ID = 'yLmBSU9KgTgewLaPTAu6MA';
  var CONVERSION_SEND_TO = 'AW-1000561475/TE3DCNXC1ascEMO2jd0D';
  var fired = false;
  var standardFallbackTimer = null;

  function parseMessage(data) {
    if (!data) {
      return null;
    }

    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (error) {
        return null;
      }
    }

    if (typeof data === 'object') {
      return data;
    }

    return null;
  }

  function hasMarketingConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') {
      return false;
    }

    var consent = privacy.currentVisitorConsent();

    return consent && consent.marketing === 'yes';
  }

  function normalizeEmail(email) {
    return normalizeText(email);
  }

  function normalizeText(value) {
    if (typeof value !== 'string') {
      return '';
    }

    return value.trim().toLowerCase();
  }

  function normalizePhone(phoneNumber) {
    if (typeof phoneNumber !== 'string') {
      return '';
    }

    return phoneNumber.trim();
  }

  function buildUserData(payload) {
    var userData = {};
    var email = normalizeEmail(payload.email);
    var phoneNumber = normalizePhone(payload.phoneNumber || payload.phone_number);
    var firstName = normalizeText(payload.firstName || payload.first_name);
    var lastName = normalizeText(payload.lastName || payload.last_name);

    if (email) {
      userData.email = email;
    }

    if (phoneNumber) {
      userData.phone_number = phoneNumber;
    }

    if (firstName || lastName) {
      userData.address = {};

      if (firstName) {
        userData.address.first_name = firstName;
      }

      if (lastName) {
        userData.address.last_name = lastName;
      }
    }

    return userData;
  }

  function hasUserData(userData) {
    return Boolean(userData.email || userData.phone_number || userData.address);
  }

  function waitForGtag(callback, attempt) {
    attempt = attempt || 0;

    if (typeof window.gtag === 'function') {
      callback(window.gtag);
      return;
    }

    if (attempt >= 40) {
      return;
    }

    window.setTimeout(function () {
      waitForGtag(callback, attempt + 1);
    }, 100);
  }

  function clearStandardFallback() {
    if (!standardFallbackTimer) {
      return;
    }

    window.clearTimeout(standardFallbackTimer);
    standardFallbackTimer = null;
  }

  function fireConversion(payload) {
    if (fired || !hasMarketingConsent()) {
      return;
    }

    fired = true;
    clearStandardFallback();

    waitForGtag(function (gtag) {
      var userData = buildUserData(payload);

      if (hasUserData(userData)) {
        gtag('set', 'user_data', userData);
      }

      gtag('event', 'conversion', {
        send_to: CONVERSION_SEND_TO,
        event_category: 'Werkstattservice form submission',
        event_action: 'Werkstattservice successful form submission',
        event_label: window.location.href,
        form_id: FORM_ID
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'cwc_workshop_service_lead_parent_fired',
        form_id: FORM_ID
      });
    });
  }

  function buildStandardSubmissionPayload(payload) {
    var data = payload && payload.payload;

    if (!data || data.form_id !== FORM_ID) {
      return null;
    }

    return {
      email: data.email || ''
    };
  }

  function scheduleStandardFallback(payload) {
    clearStandardFallback();

    standardFallbackTimer = window.setTimeout(function () {
      standardFallbackTimer = null;
      fireConversion(payload);
    }, 1500);
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== ALLOWED_ORIGIN) {
      return;
    }

    var payload = parseMessage(event.data);

    if (!payload) {
      return;
    }

    if (payload.type === 'form_submitted') {
      var standardPayload = buildStandardSubmissionPayload(payload);

      if (standardPayload) {
        scheduleStandardFallback(standardPayload);
      }

      return;
    }

    if (payload.type === 'cwc_workshop_service_lead' && payload.formId === FORM_ID) {
      fireConversion(payload);
    }
  });
})();
